import React, { useContext, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
// import "../../assets/css/custom.css";
import "../../assets/css/customNew.scss";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { saveLoginUserAccessToken } from "../../redux/action/login";
import { AllContext } from "../../context";
import { saveSideMenuData, saveCompanyData, savePaymentSettinsData } from "../../redux/action/sidemenu"
import $ from "jquery";
import ReactTooltip from "react-tooltip";

//Images
import Logo from "../../assets/img/logo.svg";
import LogoMini from "../../assets/img/logo-mini.svg";
import defaultFavIcon from "../../assets/img/favicon.svg";

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sideMenuData, companyData, paymentSettingData } = useSelector((state) => state.sideMenuReducer);

  const [currTab, setCurrTab] = useState("");
  const [menuData, setMenuData] = useState(sideMenuData);
  const [initialLoading, setInitialLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props?.toggleSideBar) {
      $(".commonSlidePl").addClass("toggle");
      $(".openArrowIcon").addClass("rotate");
      $(".openArrowIcon").addClass("toggle");
    } else {
      $(".commonSlidePl").removeClass("toggle");
      $(".openArrowIcon").removeClass("rotate");
      $(".openArrowIcon").removeClass("toggle");
    }
  })

  useEffect(() => { }, [currTab]);
  const areFalse = (value) =>
    Object.values(value).every((value) => value === false);
  const roleList = useSelector((state) => state?.loginReducer?.loginUserInfo);
  let loggedIn = localStorage.getItem("userLoggedIn");
  const context = useContext(AllContext);
  const loginUserAccessToken = useSelector(
    (state) => state.loginReducer.loginUserAccessToken
  );
  const {
    allApiUrl,
    toastMessage,
    redirectToLogin,
    apiGetMethod,
  } = context;
  const { } = context;
  useEffect(() => {
    if (
      loggedIn &&
      areFalse(roleList?.roles?.clients) &&
      areFalse(roleList?.roles?.coupons) &&
      areFalse(roleList?.roles?.invoiceAndSubscriptionAccess) &&
      areFalse(roleList?.roles?.invoiceManagement) &&
      areFalse(roleList?.roles?.messaging) &&
      areFalse(roleList?.roles?.orderAccess) &&
      areFalse(roleList?.roles?.orderManagement) &&
      areFalse(roleList?.roles?.services) &&
      areFalse(roleList?.roles?.settingsAndTeam) &&
      areFalse(roleList?.roles?.ticketAccess) &&
      areFalse(roleList?.roles?.ticketManagement) &&
      roleList?.roles?.name === "admin"
    ) {
      dispatch(saveLoginUserAccessToken(""));
      localStorage.removeItem("userLoggedIn");
      navigate("/permissionDenied", {
        state: {
          noPermission: true,
        },
      });
    }

    if (sideMenuData.length === 0) {
      getSideBarMenus();
    }
    if (!companyData || !Object.keys(companyData).length) {
      getCompanyData();
    }
    if (!paymentSettingData || !Object.keys(paymentSettingData).length) {
      getPyamentSettingData();
    }
  }, []);

  useEffect(() => {
    if (sideMenuData.length > 0) {
      setMenuData(sideMenuData);
    }
  }, [sideMenuData]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = companyData?.favicon ? companyData.favicon : defaultFavIcon;
  }, [companyData?.favicon]);

  async function getSideBarMenus() {
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    try {
      const response = await apiGetMethod(allApiUrl.SIDENAVBARS, "", header);
      let array = [];
      if (response.status === 200) {
        response.data.filter((item) => {
          if (item.show) {
            array.push(item);
          }
        });
        dispatch(saveSideMenuData(array));
        setInitialLoading(false);
      }
    } catch (err) {
      redirectToLogin(dispatch, navigate, err);
      setIsLoading(false);
      setInitialLoading(false);
      toastMessage("error", err.data.message);
    }
  }

  const getCompanyData = async () => {
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    try {
      const response = await apiGetMethod(allApiUrl.COMPANY, "", header);
      if (response.status === 200) {
        dispatch(saveCompanyData(response.data));
        setInitialLoading(false);
      }
    } catch (err) {
      redirectToLogin(dispatch, navigate, err);
      setIsLoading(false);
      setInitialLoading(false);
      toastMessage("error", err.data.message);
    }
  }

  const getPyamentSettingData = () => {
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    apiGetMethod(allApiUrl.PAYMENT_METHOD, "", header)
      .then((res) => {
        if (res.status === 200) {
          dispatch(savePaymentSettinsData(res.data.values));
          setIsLoading(false);
        }
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        setIsLoading(false);
        toastMessage("error", err.data.message);
      });
  }

  useEffect(() => {
    setCurrTab(props.activePage);
  });
  function homePageRouteHandler() {
    if (roleList?.roles?.name === "admin") {
      navigate("/dashboard");
    } else {
      navigate("/home", {
        state: {
          showBackToClientButton: false,
        },
      });
    }
  }
  function activTabHandler(value, item = null) {
    if (item && item.newTab) {
      const baseUrl = window.location.protocol + '//' + window.location.host;
      window.open(baseUrl + '/' + value, '_blank')
    } else {
      setCurrTab(value);
      navigate(`/${value}`);
    }
  }
  const allTrueChecker = (value) => {
    let result = Object.values(value).every((v) => v === false);
    return result;
  };
  function onLayoutHandler(values) {
    if (values.url.includes('https') || values.url.includes('http') || values.url.includes('www')) {
      let url = values.url.includes('https') ? values.url : `https://${values.url}`;
      let target = values.newTab ? "_blank" : "_self";
      window.open(url, target);
    } else {
      let target = values.newTab
      const url = values.url
      if (target) {
        window.open(url, '_blank');
      } else {
        navigate(url)
      }
    }

  }
  return (
    <div className={props?.toggleSideBar ? "sectionSidebar sidebarActive" : "sectionSidebar"}>
      <div className="sidebarInner">
        <span className="iconCross" onClick={() => props.setToggleSidebar(false)}>
          <i className="fa-solid fa-xmark"></i>
        </span>
        <div className="logo">
          <Link onClick={homePageRouteHandler} to="/" className="flex-column">
            <div className="company-logo my-1">
              <img className="logoMain" src={companyData?.lightLogo || Logo} alt={companyData?.companyName ? companyData.companyName : 'OpFlow'} />
              <img className="logoMini" src={companyData?.lightLogo || LogoMini} alt={companyData?.companyName ? companyData.companyName : 'OpFlow'} />
            </div>
            {/* <div className="company-name my-2 ms-1">{companyData?.companyName ? companyData.companyName : 'OpFlow'}</div> */}
          </Link>
        </div>
        {roleList?.roles?.type === "admin" ? (
          <ul>
            <li className="menuHeading">Activity</li>
            <li className={currTab === "dashboard" ? "active" : ""} onClick={() => activTabHandler("dashboard")} >
              <a data-tip="Dashboard" data-for='toolSiebar' data-place='top'>
                <span className="navlinksIcon">
                  {/* <img src={homeIcon} /> */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM15.833 7.337C15.9477 7.25654 16.0871 7.21915 16.2267 7.2314C16.3663 7.24366 16.4971 7.30478 16.596 7.404C16.6947 7.50274 16.7553 7.63329 16.7668 7.77245C16.7783 7.91161 16.7401 8.05035 16.659 8.164C14.479 11.21 13.279 12.842 13.061 13.061C12.7794 13.342 12.3978 13.4999 12 13.4999C11.6022 13.4999 11.2206 13.342 10.939 13.061C10.658 12.7794 10.5001 12.3978 10.5001 12C10.5001 11.6022 10.658 11.2206 10.939 10.939C11.313 10.566 12.944 9.365 15.833 7.337ZM17.5 11C17.7652 11 18.0196 11.1054 18.2071 11.2929C18.3946 11.4804 18.5 11.7348 18.5 12C18.5 12.2652 18.3946 12.5196 18.2071 12.7071C18.0196 12.8946 17.7652 13 17.5 13C17.2348 13 16.9804 12.8946 16.7929 12.7071C16.6054 12.5196 16.5 12.2652 16.5 12C16.5 11.7348 16.6054 11.4804 16.7929 11.2929C16.9804 11.1054 17.2348 11 17.5 11ZM6.5 11C6.76522 11 7.01957 11.1054 7.20711 11.2929C7.39464 11.4804 7.5 11.7348 7.5 12C7.5 12.2652 7.39464 12.5196 7.20711 12.7071C7.01957 12.8946 6.76522 13 6.5 13C6.23478 13 5.98043 12.8946 5.79289 12.7071C5.60536 12.5196 5.5 12.2652 5.5 12C5.5 11.7348 5.60536 11.4804 5.79289 11.2929C5.98043 11.1054 6.23478 11 6.5 11ZM8.818 7.404C9.00551 7.59177 9.11074 7.84634 9.11056 8.11171C9.11037 8.37707 9.00477 8.63149 8.817 8.819C8.62923 9.00651 8.37466 9.11174 8.10929 9.11156C7.84393 9.11137 7.58951 9.00577 7.402 8.818C7.30916 8.72502 7.23553 8.61467 7.18534 8.49324C7.13514 8.37181 7.10935 8.24169 7.10944 8.11029C7.10954 7.9789 7.13551 7.84881 7.18588 7.72745C7.23625 7.60609 7.31002 7.49584 7.403 7.403C7.59077 7.21549 7.84534 7.11026 8.11071 7.11044C8.2421 7.11054 8.37219 7.13651 8.49355 7.18688C8.61491 7.23725 8.72516 7.31102 8.818 7.404ZM12 5.5C12.2652 5.5 12.5196 5.60536 12.7071 5.79289C12.8946 5.98043 13 6.23478 13 6.5C13 6.76522 12.8946 7.01957 12.7071 7.20711C12.5196 7.39464 12.2652 7.5 12 7.5C11.7348 7.5 11.4804 7.39464 11.2929 7.20711C11.1054 7.01957 11 6.76522 11 6.5C11 6.23478 11.1054 5.98043 11.2929 5.79289C11.4804 5.60536 11.7348 5.5 12 5.5Z" fill="#242525" />
                  </svg>
                </span>
                <span className="navlinksText">Dashboard</span>
              </a>
            </li>

            {roleList?.roles?.orderAccess &&
              roleList?.roles?.orderManagement &&
              (!allTrueChecker(roleList?.roles?.orderAccess)) && (
                <li className={currTab === "orders" ? "active" : ""} onClick={() => activTabHandler("orders")}>
                  <a data-tip="Orders" data-for='toolSiebar' data-place='top'>
                    <span className="navlinksIcon">
                      {/* <i className="fa-solid fa-inbox"></i> */}
                      {/* <img src={orderIcon} /> */}

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.425 16.575H9.525L14.975 11.125L12.875 9.025L7.425 14.475V16.575ZM15.575 10.525L16.275 9.825C16.475 9.625 16.575 9.39167 16.575 9.125C16.575 8.85833 16.475 8.625 16.275 8.425L15.575 7.725C15.375 7.525 15.1417 7.425 14.875 7.425C14.6083 7.425 14.375 7.525 14.175 7.725L13.475 8.425L15.575 10.525ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />
                      </svg>

                    </span>
                    <span className="navlinksText">Orders</span>
                  </a>
                </li>
              )}

            {roleList?.roles?.clients?.view && (
              <li className={currTab === "clients" ? "active" : ""} onClick={() => activTabHandler("clients")}>
                <a data-tip="Clients" data-for='toolSiebar' data-place='top'>
                  <span className="strokeSection navlinksIcon">
                    {/* <i className="fa-solid fa-user"></i> */}
                    {/* <img src={iconUser} /> */}

                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.7191 19.752L16.0791 14.628C15.9884 13.9022 15.6357 13.2346 15.0873 12.7506C14.5388 12.2667 13.8325 11.9997 13.1011 12H10.8971C10.166 12.0002 9.46016 12.2674 8.91217 12.7513C8.36417 13.2352 8.01174 13.9026 7.92108 14.628L7.28008 19.752C7.24491 20.0335 7.27002 20.3193 7.35376 20.5903C7.4375 20.8614 7.57796 21.1116 7.76579 21.3242C7.95362 21.5368 8.18454 21.707 8.44321 21.8235C8.70188 21.94 8.98238 22.0002 9.26608 22H14.7341C15.0177 22.0001 15.2981 21.9398 15.5566 21.8232C15.8152 21.7066 16.046 21.5364 16.2337 21.3238C16.4214 21.1112 16.5618 20.8611 16.6455 20.5901C16.7292 20.3191 16.7543 20.0334 16.7191 19.752Z" stroke="#242525" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12 8C13.6569 8 15 6.65685 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8Z" stroke="#242525" strokeWidth="2" />
                      <path d="M4 11C5.10457 11 6 10.1046 6 9C6 7.89543 5.10457 7 4 7C2.89543 7 2 7.89543 2 9C2 10.1046 2.89543 11 4 11Z" stroke="#242525" strokeWidth="2" />
                      <path d="M20 11C21.1046 11 22 10.1046 22 9C22 7.89543 21.1046 7 20 7C18.8954 7 18 7.89543 18 9C18 10.1046 18.8954 11 20 11Z" stroke="#242525" strokeWidth="2" />
                      <path d="M4.00009 14H3.69409C3.22065 13.9999 2.76254 14.1678 2.40126 14.4738C2.03998 14.7798 1.79897 15.204 1.72109 15.671L1.38809 17.671C1.3403 17.9575 1.35551 18.2511 1.43265 18.5311C1.5098 18.8112 1.64704 19.0711 1.83481 19.2928C2.02259 19.5144 2.2564 19.6925 2.51998 19.8146C2.78356 19.9368 3.07058 20 3.36109 20H7.00009M20.0001 14H20.3061C20.7795 13.9999 21.2376 14.1678 21.5989 14.4738C21.9602 14.7798 22.2012 15.204 22.2791 15.671L22.6121 17.671C22.6599 17.9575 22.6447 18.2511 22.5675 18.5311C22.4904 18.8112 22.3531 19.0711 22.1654 19.2928C21.9776 19.5144 21.7438 19.6925 21.4802 19.8146C21.2166 19.9368 20.9296 20 20.6391 20H17.0001" stroke="#242525" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="navlinksText">Clients</span>
                </a>
              </li>
            )}

            <li className={currTab === "files" ? "active" : ""} onClick={() => activTabHandler("files")}>
              <a data-tip="Files" data-for='toolSiebar' data-place='top'>
                <span className="navlinksIcon">
                  {/* <i className="fa-solid fa-file"></i> */}
                  {/* <img src={fileIcon} /> */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.6709 5.57906L16.9209 1.82906C16.8164 1.72462 16.6923 1.64181 16.5557 1.58535C16.4191 1.52889 16.2728 1.49988 16.125 1.5H8.625C8.12772 1.5 7.65081 1.69754 7.29917 2.04918C6.94754 2.40081 6.75 2.87772 6.75 3.375V5.25H5.25C4.75272 5.25 4.27581 5.44754 3.92417 5.79918C3.57254 6.15081 3.375 6.62772 3.375 7.125V20.25C3.375 20.7473 3.57254 21.2242 3.92417 21.5758C4.27581 21.9275 4.75272 22.125 5.25 22.125H15.375C15.8723 22.125 16.3492 21.9275 16.7008 21.5758C17.0525 21.2242 17.25 20.7473 17.25 20.25V18.375H19.125C19.6223 18.375 20.0992 18.1775 20.4508 17.8258C20.8025 17.4742 21 16.9973 21 16.5V6.375C21.0001 6.22722 20.9711 6.08086 20.9147 5.94429C20.8582 5.80772 20.7754 5.68362 20.6709 5.57906ZM15 19.875H5.625V7.5H11.9062L15 10.5938V19.875ZM18.75 16.125H17.25V10.125C17.2501 9.97722 17.2211 9.83086 17.1647 9.69429C17.1082 9.55772 17.0254 9.43362 16.9209 9.32906L13.1709 5.57906C13.0664 5.47462 12.9423 5.39181 12.8057 5.33535C12.6691 5.27889 12.5228 5.24988 12.375 5.25H9V3.75H15.6562L18.75 6.84375V16.125ZM13.5 13.5C13.5 13.7984 13.3815 14.0845 13.1705 14.2955C12.9595 14.5065 12.6734 14.625 12.375 14.625H8.25C7.95163 14.625 7.66548 14.5065 7.4545 14.2955C7.24353 14.0845 7.125 13.7984 7.125 13.5C7.125 13.2016 7.24353 12.9155 7.4545 12.7045C7.66548 12.4935 7.95163 12.375 8.25 12.375H12.375C12.6734 12.375 12.9595 12.4935 13.1705 12.7045C13.3815 12.9155 13.5 13.2016 13.5 13.5ZM13.5 17.25C13.5 17.5484 13.3815 17.8345 13.1705 18.0455C12.9595 18.2565 12.6734 18.375 12.375 18.375H8.25C7.95163 18.375 7.66548 18.2565 7.4545 18.0455C7.24353 17.8345 7.125 17.5484 7.125 17.25C7.125 16.9516 7.24353 16.6655 7.4545 16.4545C7.66548 16.2435 7.95163 16.125 8.25 16.125H12.375C12.6734 16.125 12.9595 16.2435 13.1705 16.4545C13.3815 16.6655 13.5 16.9516 13.5 17.25Z" />
                  </svg>
                </span>
                <span className="navlinksText">Files</span>
              </a>
            </li>
            {roleList?.roles?.ticketAccess &&
              roleList?.roles?.ticketManagement &&
              (!allTrueChecker(roleList?.roles?.ticketAccess)) && (
                <li className={currTab === "tickets" ? "active" : ""} onClick={() => activTabHandler("tickets")}>
                  <a data-tip="Tickets" data-for='toolSiebar' data-place='top'>
                    <span className="strokeSection navlinksIcon">
                      {/* <i className="fa-solid fa-comment"></i> */}
                      {/* <img src={ticketIcon} /> */}

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 5V7M13 17V19M13 11V13M3 7V9C3.79565 9 4.55871 9.31607 5.12132 9.87868C5.68393 10.4413 6 11.2044 6 12C6 12.7956 5.68393 13.5587 5.12132 14.1213C4.55871 14.6839 3.79565 15 3 15V17C3 18.1 3.9 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V15C20.2044 15 19.4413 14.6839 18.8787 14.1213C18.3161 13.5587 18 12.7956 18 12C18 11.2044 18.3161 10.4413 18.8787 9.87868C19.4413 9.31607 20.2044 9 21 9V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7Z" stroke="#242525" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>

                    </span>
                    <span className="navlinksText">Tickets</span>
                  </a>
                </li>
              )}
            {(roleList?.roles?.invoiceAndSubscriptionAccess.allInvoices ||
              roleList?.roles?.invoiceAndSubscriptionAccess.ownInvoices) && (
                <>
                  <li className="menuHeading">Billing</li>
                  <li className={currTab === "invoices" ? "active" : ""} onClick={() => activTabHandler("invoices")}>
                    <a data-tip="Invoices" data-for='toolSiebar' data-place='top'>
                      <span className="navlinksIcon">
                        {/* <i className="fa-solid fa-file-invoice"></i> */}
                        {/* <img src={invoiceIcon} /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.16016 11.205H16.0502V13.08H8.16016V11.205ZM8.16016 14.745H16.0502V16.62H8.16016V14.745ZM8.16016 7.60498H16.0502V9.47998H8.16016V7.60498Z" />
                          <path d="M17.0099 1.5L14.4599 0.42L12.1199 1.5L9.61494 0.42L7.25994 1.5L3.68994 0V24L7.25994 22.5L9.61494 23.535L12.1199 22.5L14.4599 23.535L17.0099 22.5L20.3099 24V0L17.0099 1.5ZM18.4199 21.165L17.0399 20.55L14.5049 21.585L12.1499 20.505L9.62994 21.54L7.30494 20.505L5.57994 21.21V2.79L7.30494 3.495L9.62994 2.46L12.1499 3.495L14.5049 2.46L17.0399 3.495L18.4199 2.88V21.165Z" />
                        </svg>
                      </span>
                      <span className="navlinksText">Invoices</span>
                    </a>
                  </li>
                  <li className={currTab === "subscription" ? "active" : ""} onClick={() => activTabHandler("subscription")}>
                    <a data-tip="Subscriptions" data-for='toolSiebar' data-place='top'>
                      <span className="navlinksIcon">
                        {/* <i className="fa-solid fa-arrows-rotate"></i> */}
                        {/* <img src={subscribeIcon} /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 4C7.71667 4 7.479 3.904 7.287 3.712C7.09567 3.52067 7 3.28333 7 3C7 2.71667 7.09567 2.479 7.287 2.287C7.479 2.09567 7.71667 2 8 2H16C16.2833 2 16.5207 2.09567 16.712 2.287C16.904 2.479 17 2.71667 17 3C17 3.28333 16.904 3.52067 16.712 3.712C16.5207 3.904 16.2833 4 16 4H8ZM5 7C4.71667 7 4.479 6.90433 4.287 6.713C4.09567 6.521 4 6.28333 4 6C4 5.71667 4.09567 5.479 4.287 5.287C4.479 5.09567 4.71667 5 5 5H19C19.2833 5 19.5207 5.09567 19.712 5.287C19.904 5.479 20 5.71667 20 6C20 6.28333 19.904 6.521 19.712 6.713C19.5207 6.90433 19.2833 7 19 7H5ZM4 22C3.45 22 2.97933 21.8043 2.588 21.413C2.196 21.021 2 20.55 2 20V10C2 9.45 2.196 8.979 2.588 8.587C2.97933 8.19567 3.45 8 4 8H20C20.55 8 21.021 8.19567 21.413 8.587C21.8043 8.979 22 9.45 22 10V20C22 20.55 21.8043 21.021 21.413 21.413C21.021 21.8043 20.55 22 20 22H4ZM4 20H20V10H4V20ZM11.55 17.975L14.75 15.825C15.05 15.625 15.2 15.35 15.2 15C15.2 14.65 15.05 14.375 14.75 14.175L11.55 12.025C11.2167 11.7917 10.875 11.775 10.525 11.975C10.175 12.175 10 12.475 10 12.875V17.125C10 17.525 10.175 17.825 10.525 18.025C10.875 18.225 11.2167 18.2083 11.55 17.975Z" />
                        </svg>
                      </span>
                      <span className="navlinksText">Subscriptions</span>
                    </a>
                  </li>
                </>
              )}
            {roleList?.roles?.coupons?.view_add_edit_delete && (
              <>
                <li className="menuHeading">Marketing</li>
                <li className={currTab === "coupons" ? "active" : ""} onClick={() => activTabHandler("coupons")}>
                  <a data-tip="Coupons" data-for='toolSiebar' data-place='top'>
                    <span className="navlinksIcon">
                      {/* <i className="fa-solid fa-ticket"></i> */}
                      {/* <img src={couponIcon} /> */}
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8ZM4 4H20C21.11 4 22 4.89 22 6V10C21.4696 10 20.9609 10.2107 20.5858 10.5858C20.2107 10.9609 20 11.4696 20 12C20 12.5304 20.2107 13.0391 20.5858 13.4142C20.9609 13.7893 21.4696 14 22 14V18C22 19.11 21.11 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V14C3.11 14 4 13.11 4 12C4 11.4696 3.78929 10.9609 3.41421 10.5858C3.03914 10.2107 2.53043 10 2 10V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4ZM4 6V8.54C4.60768 8.8904 5.11236 9.39466 5.46325 10.0021C5.81415 10.6094 5.9989 11.2985 5.9989 12C5.9989 12.7015 5.81415 13.3906 5.46325 13.9979C5.11236 14.6053 4.60768 15.1096 4 15.46V18H20V15.46C19.3923 15.1096 18.8876 14.6053 18.5367 13.9979C18.1858 13.3906 18.0011 12.7015 18.0011 12C18.0011 11.2985 18.1858 10.6094 18.5367 10.0021C18.8876 9.39466 19.3923 8.8904 20 8.54V6H4ZM9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11C8.67 11 8 10.33 8 9.5C8 8.67 8.67 8 9.5 8ZM14.5 13C15.33 13 16 13.67 16 14.5C16 15.33 15.33 16 14.5 16C13.67 16 13 15.33 13 14.5C13 13.67 13.67 13 14.5 13Z" />
                      </svg>
                    </span>
                    <span className="navlinksText">Coupons</span>
                  </a>
                </li>
              </>
            )}
            {(roleList?.roles?.services?.view_add_edit_delete ||
              roleList?.roles?.settingsAndTeam?.view_add_edit) && (
                <li className="menuHeading">Setup</li>
              )}
            {roleList?.roles?.services?.view_add_edit_delete && (
              <li className={currTab === "services" ? "active" : ""} onClick={() => activTabHandler("services")}>
                <a data-tip="Services" data-for='toolSiebar' data-place='top'>
                  <span className="navlinksIcon">
                    {/* <i className="fa-solid fa-suitcase"></i> */}
                    {/* <img src={serviceIcon} /> */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 19.5V9.5C2 8.8125 2.196 8.22375 2.588 7.73375C2.97933 7.24458 3.45 7 4 7H7V4.5C7 3.8125 7.196 3.22417 7.588 2.735C7.97933 2.245 8.45 2 9 2H15C15.55 2 16.021 2.245 16.413 2.735C16.8043 3.22417 17 3.8125 17 4.5V7H20C20.55 7 21.021 7.24458 21.413 7.73375C21.8043 8.22375 22 8.8125 22 9.5V19.5C22 20.1875 21.8043 20.7763 21.413 21.2663C21.021 21.7554 20.55 22 20 22H4C3.45 22 2.97933 21.7554 2.588 21.2663C2.196 20.7763 2 20.1875 2 19.5ZM4 19.5H20V15.75H18C18 16.1042 17.904 16.4008 17.712 16.64C17.5207 16.88 17.2833 17 17 17C16.7167 17 16.4793 16.88 16.288 16.64C16.096 16.4008 16 16.1042 16 15.75H8C8 16.1042 7.90433 16.4008 7.713 16.64C7.521 16.88 7.28333 17 7 17C6.71667 17 6.479 16.88 6.287 16.64C6.09567 16.4008 6 16.1042 6 15.75H4V19.5ZM4 9.5V13.25H6C6 12.8958 6.09567 12.5987 6.287 12.3587C6.479 12.1196 6.71667 12 7 12C7.28333 12 7.521 12.1196 7.713 12.3587C7.90433 12.5987 8 12.8958 8 13.25H16C16 12.8958 16.096 12.5987 16.288 12.3587C16.4793 12.1196 16.7167 12 17 12C17.2833 12 17.5207 12.1196 17.712 12.3587C17.904 12.5987 18 12.8958 18 13.25H20V9.5H4ZM9 7H15V4.5H9V7Z" />
                    </svg>
                  </span>
                  <span className="navlinksText">Services</span>
                </a>
              </li>
            )}
            {roleList?.roles?.settingsAndTeam?.view_add_edit && (
              <li className={currTab === "settings" ? "active" : ""} onClick={() => activTabHandler("settings")}>
                <a data-tip="Settings" data-for='toolSiebar' data-place='top'>
                  <span className="navlinksIcon">
                    {/* <i className="fa-solid fa-gear"></i> */}
                    {/* <img src={settingIcon} /> */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.8999 12.6604C19.7396 12.4779 19.6512 12.2433 19.6512 12.0004C19.6512 11.7575 19.7396 11.5229 19.8999 11.3404L21.1799 9.90038C21.3209 9.74305 21.4085 9.54509 21.4301 9.33489C21.4516 9.12469 21.4061 8.91307 21.2999 8.73038L19.2999 5.27038C19.1948 5.0879 19.0348 4.94326 18.8426 4.85707C18.6505 4.77088 18.4361 4.74754 18.2299 4.79038L16.3499 5.17038C16.1107 5.21981 15.8616 5.17997 15.6498 5.05838C15.4379 4.93679 15.2779 4.74187 15.1999 4.51038L14.5899 2.68038C14.5228 2.48176 14.395 2.30925 14.2245 2.18723C14.0541 2.0652 13.8495 1.99984 13.6399 2.00038H9.6399C9.42183 1.989 9.20603 2.04931 9.02546 2.1721C8.84489 2.29489 8.70948 2.4734 8.6399 2.68038L8.0799 4.51038C8.0019 4.74187 7.84187 4.93679 7.63001 5.05838C7.41815 5.17997 7.16911 5.21981 6.9299 5.17038L4.9999 4.79038C4.80445 4.76276 4.6052 4.79361 4.42724 4.87902C4.24929 4.96444 4.1006 5.10061 3.9999 5.27038L1.9999 8.73038C1.89106 8.91103 1.84212 9.12147 1.86008 9.33161C1.87804 9.54174 1.96198 9.74082 2.0999 9.90038L3.3699 11.3404C3.53022 11.5229 3.61863 11.7575 3.61863 12.0004C3.61863 12.2433 3.53022 12.4779 3.3699 12.6604L2.0999 14.1004C1.96198 14.2599 1.87804 14.459 1.86008 14.6692C1.84212 14.8793 1.89106 15.0897 1.9999 15.2704L3.9999 18.7304C4.10499 18.9129 4.26502 19.0575 4.45715 19.1437C4.64928 19.2299 4.86372 19.2532 5.0699 19.2104L6.9499 18.8304C7.18911 18.781 7.43815 18.8208 7.65001 18.9424C7.86187 19.064 8.0219 19.2589 8.0999 19.4904L8.7099 21.3204C8.77948 21.5274 8.91489 21.7059 9.09546 21.8287C9.27603 21.9515 9.49183 22.0118 9.7099 22.0004H13.7099C13.9195 22.0009 14.1241 21.9356 14.2945 21.8135C14.465 21.6915 14.5928 21.519 14.6599 21.3204L15.2699 19.4904C15.3479 19.2589 15.5079 19.064 15.7198 18.9424C15.9316 18.8208 16.1807 18.781 16.4199 18.8304L18.2999 19.2104C18.5061 19.2532 18.7205 19.2299 18.9126 19.1437C19.1048 19.0575 19.2648 18.9129 19.3699 18.7304L21.3699 15.2704C21.4761 15.0877 21.5216 14.8761 21.5001 14.6659C21.4785 14.4557 21.3909 14.2577 21.2499 14.1004L19.8999 12.6604ZM18.4099 14.0004L19.2099 14.9004L17.9299 17.1204L16.7499 16.8804C16.0297 16.7332 15.2805 16.8555 14.6445 17.2242C14.0085 17.5929 13.53 18.1822 13.2999 18.8804L12.9199 20.0004H10.3599L9.9999 18.8604C9.76975 18.1622 9.29128 17.5729 8.6553 17.2042C8.01932 16.8355 7.27012 16.7132 6.5499 16.8604L5.3699 17.1004L4.0699 14.8904L4.8699 13.9904C5.36185 13.4404 5.63383 12.7283 5.63383 11.9904C5.63383 11.2525 5.36185 10.5404 4.8699 9.99038L4.0699 9.09038L5.3499 6.89038L6.5299 7.13038C7.25012 7.27761 7.99932 7.15526 8.6353 6.78658C9.27128 6.4179 9.74975 5.82854 9.9799 5.13038L10.3599 4.00038H12.9199L13.2999 5.14038C13.53 5.83854 14.0085 6.4279 14.6445 6.79658C15.2805 7.16526 16.0297 7.28761 16.7499 7.14038L17.9299 6.90038L19.2099 9.12038L18.4099 10.0204C17.9235 10.5691 17.6549 11.2771 17.6549 12.0104C17.6549 12.7437 17.9235 13.4516 18.4099 14.0004ZM11.6399 8.00038C10.8488 8.00038 10.0754 8.23498 9.41761 8.67451C8.75982 9.11403 8.24713 9.73874 7.94438 10.4696C7.64163 11.2006 7.56241 12.0048 7.71675 12.7807C7.8711 13.5567 8.25206 14.2694 8.81147 14.8288C9.37088 15.3882 10.0836 15.7692 10.8595 15.9235C11.6355 16.0779 12.4397 15.9987 13.1706 15.6959C13.9015 15.3932 14.5262 14.8805 14.9658 14.2227C15.4053 13.5649 15.6399 12.7915 15.6399 12.0004C15.6399 10.9395 15.2185 9.9221 14.4683 9.17196C13.7182 8.42181 12.7008 8.00038 11.6399 8.00038ZM11.6399 14.0004C11.2443 14.0004 10.8577 13.8831 10.5288 13.6633C10.1999 13.4436 9.94351 13.1312 9.79214 12.7657C9.64076 12.4003 9.60116 11.9982 9.67833 11.6102C9.7555 11.2222 9.94598 10.8659 10.2257 10.5862C10.5054 10.3065 10.8618 10.116 11.2497 10.0388C11.6377 9.96164 12.0398 10.0012 12.4053 10.1526C12.7707 10.304 13.0831 10.5603 13.3028 10.8892C13.5226 11.2181 13.6399 11.6048 13.6399 12.0004C13.6399 12.5308 13.4292 13.0395 13.0541 13.4146C12.679 13.7897 12.1703 14.0004 11.6399 14.0004Z" />
                    </svg>
                  </span>
                  <span className="navlinksText">Settings</span>
                </a>
              </li>
            )}
            <ReactTooltip id="toolSiebar" backgroundColor="#007d87" />
          </ul>
        ) : (
          <ul className="clientMenus">
            <li className={currTab === "home" ? "active" : ""} onClick={() => activTabHandler("home")}>
              <a data-tip="Dashboard" data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`fa-solid fa-house`}></i>
                </span>
                <span className="navlinksText">{'Dashboard'}</span>
              </a>
            </li>
            <li className={currTab === "purchases" ? "active" : ""} onClick={() => activTabHandler("purchases")}>
              <a data-tip="My Purchases" data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`fa-solid fa-ticket`}></i>
                </span>
                <span className="navlinksText">{'My Purchases'}</span>
              </a>
            </li>
            <li className={currTab === "shop" ? "active" : ""} onClick={() => activTabHandler("shop")}>
              <a data-tip="Services" data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`fa-regular fa-newspaper`}></i>
                </span>
                <span className="navlinksText">{'Services'}</span>
              </a>
            </li>
            <li className={currTab === "help" ? "active" : ""} onClick={() => activTabHandler("help")}>
              <a data-tip="Help" data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`fa-solid fa-handshake-angle`}></i>
                </span>
                <span className="navlinksText">{'Help'}</span>
              </a>
            </li>
            <li className={currTab === "profile" ? "active" : ""} onClick={() => activTabHandler("profile")}>
              <a data-tip="My Profile" data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`fa-solid fa-user`}></i>
                </span>
                <span className="navlinksText">{'My Profile'}</span>
              </a>
            </li>
            <li className="menuHeading">Billing</li>
            <li
              className={currTab === 'payments' ? "active" : ""}
              onClick={() => activTabHandler("payments")}
            >
              <a data-tip={'Payments'} data-for='toolSiebarClient' data-place='top'>
                <span className="navlinksIcon">
                  <i className={`${'fa-solid fa-money-bill'}`}></i>
                </span>
                <span className="navlinksText">{'Payments'}</span>
              </a>
            </li>
            <li className="menuHeading">Layouts</li>
            {menuData.map((clientteam, index) => {
              // if (clientteam.type == "Activity") {
              //   return (
              //     <li key={index} className={currTab === clientteam.url ? "active" : ""} onClick={() => activTabHandler(clientteam.url, clientteam)}>
              //       <a data-tip={clientteam.name} data-for='toolSiebarClient' data-place='top'>
              //         <span className="navlinksIcon">
              //           <i className={`${clientteam.icon}`}></i>
              //         </span>
              //         <span className="navlinksText">{clientteam.name}</span>
              //       </a>
              //     </li>
              //   );
              // }

              // if (clientteam.type == "Billing") {
              //   return (
              //     <React.Fragment key={index}>
              //       <li className="menuHeading" key={index}>Billing</li>
              //       <li
              //         className={currTab === clientteam.url ? "active" : ""}
              //         onClick={() => activTabHandler(clientteam.url, clientteam)}
              //       >
              //         <a data-tip={clientteam.name} data-for='toolSiebarClient' data-place='top'>
              //           <span className="navlinksIcon">
              //             <i className={`${clientteam.icon}`}></i>
              //           </span>
              //           <span className="navlinksText">{clientteam.name}</span>
              //         </a>
              //       </li>
              //     </React.Fragment>
              //   );
              // } else {
              //   return (
              //     <React.Fragment key={index}>
              //       {menuData[index].type !== menuData[index - 1].type && (
              //         <li className="menuHeading">Account</li>
              //       )}

              //       <li key={index}
              //         className={currTab === clientteam.url ? "active" : ""}
              //         onClick={() => activTabHandler(clientteam.url, clientteam)}
              //       >
              //         <a data-tip={clientteam.name} data-for='toolSiebarClient' data-place='top'>
              //           <span className="navlinksIcon">
              //             <i className={`${clientteam.icon}`}></i>
              //           </span>
              //           <span className="navlinksText">{clientteam.name}</span>
              //         </a>
              //       </li>
              //     </React.Fragment>
              //   );
              // }
              return (
                <React.Fragment key={index}>
                  <li key={index} className={currTab === clientteam.url ? "active" : ""} onClick={() => onLayoutHandler(clientteam)}>
                    <a data-tip={clientteam.name} data-for='toolSiebarClient' data-place='top'>
                      <span className="navlinksIcon">
                        <i className={`${clientteam.icon}`}></i>
                      </span>
                      <span className="navlinksText">{clientteam.name}</span>
                    </a>
                  </li>
                </React.Fragment>
              );
            })}
            <ReactTooltip id="toolSiebarClient" backgroundColor="#007d87" />
          </ul>
        )}
      </div>
      {/* <div className="quickBuildApplications">
        <div className="quickBuildApplicationsInner">
          <h4>Quick Build Applications</h4>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
          <button type="button" className="commonButton">Try Now</button>
        </div>
      </div> */}
      {roleList?.roles?.type !== "admin" ? (
        <div className="contact-link text-center">
          <a
            href={
              (companyData?.contactLink && companyData?.contactLink.includes('http://')) ? companyData?.contactLink : `http://${companyData?.contactLink}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us</a>
        </div>
      ) : ''}
    </div>
  );
};
export default Sidebar;
